import React, { useEffect, useState } from 'react';
import { useCreatingNewUserAtom } from '../../atoms/users/useCreatingNewUserAtom';
import { useUserToEditAtom } from '../../atoms/users/useUserToEditAtom';
import { updateUser, deleteUser } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';

import ConfirmDeleteModal from '../../components/shared/ConfirmDeleteModal';
import RoleSelectBox from '../../components/shared/RoleSelectBox';
import TeamsMultiselect from '../../components/shared/TeamsMultiselect';

import '../../css/pages/edit_user.css';
const EditUser = () => {

  const { showNotification } = useNotification();

  const [t] = useTranslation('global');

  const [, setCreatingNewUser] = useCreatingNewUserAtom();
  const [userToEdit, setUserToEdit] = useUserToEditAtom();

  const [showEditPassword, setShowEditPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newUserName: '',
    lastName: '',
    email: '',
    roleId : '',
    teamIds: [],
    password: '',
    verifyPassword: ''
  });

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTeamChange = (event) => {
    const {
        target: { value },
    } = event;
    setFormData({
        ...formData,
        teamIds: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleShowEditPassword = () => {
    setShowEditPassword(true);
  }

  const handleGoBack = () => {
    setCreatingNewUser(false);
    navigate('/Users');
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();
    console.log('Submitting:', formData);

    if (!showEditPassword) {
      setIsLoading(true);
      updateUser(userToEdit.id, formData.newUserName, formData.lastName, '', formData.roleId, formData.teamIds)
        .then(() => {
          showNotification({ message: t('savedChanges'), type: NotificationType.Success});
          setUserToEdit(null);  
          setIsLoading(false);
          navigate('/Users');
        });
    } else {
      if (formData.password === formData.verifyPassword) {
        setIsLoading(true);
          updateUser(userToEdit.id, formData.newUserName, formData.lastName, formData.password, formData.roleId, formData.teamIds)
          .then(r => {
            console.log(r);
            showNotification({ message: t('savedChanges'), type: NotificationType.Success});
            setUserToEdit(null);
            setIsLoading(false);
            navigate('/Users');
           }).catch(error => {
              setIsLoading(false);
              if (error.response?.status === 400) {
                showNotification({ message: t('pwdRule'), type: NotificationType.Error });
              }
            });         
        } else {
          showNotification({ message: t('passwordsDontMatch'), type: NotificationType.Error });
        }
    }
  };

  const handleNo = () => {
    handleClose();
  }

  const handleYes = () => {
    handleDelete();
    handleClose();
  }

  const handleDelete = () => {
      deleteUser(userToEdit.id)
      .then(r => {
        setIsLoading(false);
        navigate('/Users');
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false); 
    });
  }

  useEffect(() => {
    if(userToEdit) {
      setFormData({
        newUserName: userToEdit.userFirstname,
        lastName: userToEdit.userLastname,
        email: userToEdit.userEmail,
        roleId: userToEdit.roleId,
        teamIds: userToEdit.teams.map(team => team.id),
        password: '',
        verifyPassword: '',
      }); 
    } else {
      navigate('/Users');
    }
  }, [userToEdit]);
  
  return (
    <div className="user_form page-wrap">
    <div className="header-title"><h1>{t('editUser')}</h1></div> 

      <ConfirmDeleteModal 
        open={open} 
        onNo={handleNo}
        onYes={handleYes}
        onClose={handleClose}
        item={t('thisUser')}
      /> 

      <form autoComplete="off" className="input-form">

        <div className="input-section">
          <div className="input-line">
            <label htmlFor="newUserName">{t('userName')}</label>
            <input
              type="text"
              id="newUserName"
              name="newUserName"
              value={formData.newUserName}
              onChange={handleChange}
              autoComplete="new-password"
            />
          </div>
          <div className="input-line">
            <label htmlFor="lastName">{t('lastName')}</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              autoComplete="new-password"
            />
          </div>
        </div> 

        <div className="input-section">      
          <div className="input-line">
            <label htmlFor="email">{t('email')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="new-password"
            />
          </div>
          <div className='input-line'>
            <div id="role-selectbox" className="selectbox-section">
              <RoleSelectBox selectValue={formData.roleId} onChange={handleChange}/>
            </div>
          </div>
        </div>

          <div className='input-line'>
            <div className='selectbox-section'>
              <TeamsMultiselect selectedValues={formData.teamIds} onChange={handleTeamChange}/>
            </div>
          </div>

        {!showEditPassword ? (
            <button className="option-button" type="button" onClick={handleShowEditPassword}>
              {t('showPasswordEdit')}
            </button>
          ) : (
            <div className="input-section">
             <div className="input-line">

              <div className='pwd-info'>
                <label htmlFor="password">{t('password')}
                </label>
                <span className="material-symbols-outlined pwd-tooltip">
                  info
                  <span className='tooltip-text'>{t('pwdRule')}</span>
                </span>
              </div>

              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>
            <div className="input-line">
              <label htmlFor="verifyPassword">{t('verifyPassword')}</label>
              <input
                type="password"
                id="verifyPassword"
                name="verifyPassword"
                value={formData.verifyPassword}
                onChange={handleChange}
                autoComplete="new-password"
              />
            </div>
            </div>
          )}
        <div>{isLoading ? t('loading') : ''}</div>
      </form>

      <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
      <button className="submit-button" type="submit" onClick={(e) => handleSubmit(e, 'save')} disabled={isLoading}>{t('save')}</button>
      <button className="delete-button" type="submit" onClick={(e) => handleOpen(e)} disabled={isLoading}>{t('deleteUser')}</button>
   
    </div> 
  );
};

export default EditUser;
